import React from 'react';
import PropTypes from 'prop-types';
import { toggleInArray } from '../../utils/immutable';
import Option from './Option';

const Question = ({
  data,
  correctInput,
  input,
  onClick,
  validationResult,
  isFinalAttempt
}) => {
  const hasValidated = validationResult !== null;

  const getFeedback = option => {
    if (hasValidated && correctInput) {
      const isCorrectOption =
        data.inputType === 'checkbox'
          ? correctInput.includes(option)
          : correctInput === option;

      if (isCorrectOption) return 'success';

      const isSelectedAndIncorrect =
        data.inputType === 'checkbox'
          ? input.includes(option)
          : input === option;

      if (isSelectedAndIncorrect) return 'error';
    }

    return null;
  };

  const isChecked = option => {
    if (input && data.inputType === 'checkbox') {
      return input.includes(option);
    }
    return input === option;
  };

  const handleClick = option => {
    if (data.inputType === 'radio') {
      onClick(data.question, option);
    } else {
      const propertyValue = toggleInArray(input, option);
      onClick(data.question, propertyValue.length ? propertyValue : null);
    }
  };

  return (
    <div className="multiple-choice__question">
      {'image' in data && (
        <div className="multiple-choice__question__image-wrapper">
          <img alt={data.imageText} src={data.image} width="350" />
        </div>
      )}
      <h3>{data.question}</h3>
      {data.options.map((option, i) => (
        <Option
          key={i}
          question={data.question}
          type={data.inputType}
          data={option}
          checked={isChecked(option.label)}
          readOnly={hasValidated}
          onClick={handleClick}
          feedback={getFeedback(option.label)}
          isFinalAttempt={isFinalAttempt}
        />
      ))}
    </div>
  );
};

Question.defaultProps = {
  correctInput: null,
  input: null,
  validationResult: null
};

Question.propTypes = {
  data: PropTypes.shape({
    inputType: PropTypes.string.isRequired,
    minOptions: PropTypes.number,
    options: PropTypes.arrayOf(PropTypes.object),
    question: PropTypes.node.isRequired
  }).isRequired,
  correctInput: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
  input: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
  validationResult: PropTypes.bool
};

export default Question;



// WEBPACK FOOTER //
// ../core/src/components/MultipleChoice/Question.js